import React from 'react';
import { X, AlertCircle } from 'lucide-react';
interface ConfirmModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title: string;
  message: string;
  confirmText?: string;
  cancelText?: string;
  type?: 'danger' | 'warning' | 'info';
}
export function ConfirmModal({
  isOpen,
  onClose,
  onConfirm,
  title,
  message,
  confirmText = 'Confirm',
  cancelText = 'Cancel',
  type = 'info'
}: ConfirmModalProps) {
  if (!isOpen) return null;
  const confirmButtonClass = type === 'danger' ? 'bg-red-600 hover:bg-red-700' : type === 'warning' ? 'bg-yellow-600 hover:bg-yellow-700' : 'bg-[#1f2933] hover:bg-gray-800';
  return <div data-testid="confirm-modal-overlay" className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4" data-id="element-514">
      <div data-testid="confirm-modal" data-confirm-type={type} className="bg-white border border-gray-300 max-w-md w-full shadow-lg" data-id="element-515">
        <div className="flex justify-between items-center p-4 border-b border-gray-200" data-id="element-516">
          <h3 data-testid="confirm-modal-title" className="font-bold text-lg flex items-center gap-2" data-id="element-517">
            <AlertCircle className="w-5 h-5 text-gray-500" data-id="element-518" />
            {title}
          </h3>
          <button data-testid="confirm-modal-close-btn" onClick={onClose} className="text-gray-400 hover:text-gray-600" data-id="element-519">
            <X className="w-5 h-5" data-id="element-520" />
          </button>
        </div>
        <div className="p-6" data-id="element-521">
          <p data-testid="confirm-modal-message" className="text-sm text-gray-700" data-id="element-522">
            {message}
          </p>
        </div>
        <div className="p-4 border-t border-gray-200 flex justify-end gap-3" data-id="element-523">
          <button data-testid="confirm-modal-cancel-btn" onClick={onClose} className="px-4 py-2 border border-gray-300 text-sm font-bold hover:bg-gray-50" data-id="element-524">
            {cancelText}
          </button>
          <button data-testid="confirm-modal-confirm-btn" onClick={() => {
          onConfirm();
          onClose();
        }} className={`px-4 py-2 text-white text-sm font-bold ${confirmButtonClass}`} data-id="element-525">
            {confirmText}
          </button>
        </div>
      </div>
    </div>;
}